import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postNotifications = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `/monitoring-operator/notifications`,
    data: payload,
  });

  return data?.data;
};

export default postNotifications;
